import React from 'react';
import { Card, Chip, styled, Typography } from '@mui/material';

export const StyledCard = styled(Card)(({ theme }) => ({
  minWidth                 : '308px',
  width                    : '308px',
  border                   : `1px solid ${theme.palette.primary.gray3}`,
  borderRadius             : '10px',
  boxSizing                : 'border-box',
  boxShadow                : 'none',
  '& .MuiCardContent-root' : {
    padding        : '20px 21px',
    display        : 'flex',
    flexDirection  : 'column',
    justifyContent : 'space-between',
    minHeight      : '262px',
    boxSizing      : 'border-box',
  },
  '& .MuiCardActions-root' : {
    padding : '20px 21px',
  },
}));

export const CardTitle = styled(Typography)(({ theme }) => ({
  color        : theme.palette.primary.grey7,
  fontFamily   : 'Montserrat',
  fontWeight   : '700',
  marginBottom : '8px',
}));

export const Description = styled(Typography)(({ theme }) => ({
  color        : '#231F20',
  fontFamily   : 'Montserrat',
  marginBottom : '8px',
}));

export const Location = styled(Typography)(({ theme }) => ({
  color           : '#909090',
  marginBottom    : '10px',
  overflow        : 'hidden',
  display         : '-webkit-box',
  WebkitLineClamp : 2,
  lineClamp       : 2,
  WebkitBoxOrient : 'vertical',
}));

export const FirstContentRow = styled('div')({});
export const SecondContentRow = styled('div')({
  margin : '20px 0',
});

export const StyledProgress = styled('div')(({ theme }) => ({
  textAlign : 'center',
  '& span'  : {
    fontFamily : '',
    fontWeight : '700',
    color      : theme.palette.primary.greenPKD,
  },
}));

export const StyledChip = styled(Chip)(({ theme }) => ({
  color        : theme.palette.primary.purple,
  borderColor  : theme.palette.primary.purple,
  fontWeight   : '700',
  marginTop    : '14px',
  marginBottom : '14px',
}));

export const Enrolled = styled('div')({
  display    : 'flex',
  alignItems : 'center',
  span       : {
    color : '#3AA203',
  },
  '& svg' : {
    width       : '30px',
    height      : '30px',
    marginRight : '10px',
  },
});
/* Explore more study opportunities card */
export const ExploreMoreCardWrapper = styled(Card)(({ theme }) => ({
  minWidth                 : '308px',
  width                    : '308px',
  border                   : `1px solid ${theme.palette.primary.gray3}`,
  borderRadius             : '10px',
  boxSizing                : 'border-box',
  boxShadow                : 'none',
  '& .MuiCardContent-root' : {
    padding        : '76px 28px',
    display        : 'flex',
    flexDirection  : 'column',
    justifyContent : 'space-between',
    minHeight      : '262px',
    boxSizing      : 'border-box',
    textAlign      : 'center',
  },
}));

export const AnchorTagLink = styled('a')({
  cursor         : 'pointer',
  textDecoration : 'none',
});

export const TitleWithLimit = styled(CardTitle)({
  overflow        : 'hidden',
  display         : '-webkit-box',
  WebkitLineClamp : 2,
  lineClamp       : 2,
  WebkitBoxOrient : 'vertical',
});

export const DescriptionWithLimit = styled(Description)({
  overflow        : 'hidden',
  display         : '-webkit-box',
  WebkitLineClamp : 5,
  lineClamp       : 5,
  WebkitBoxOrient : 'vertical',
});
